import "./styles/MobileBottomMenu.scss";
import { NavLink, Route, Switch, useHistory } from "react-router-dom";
import { useAppSelector } from "../../RootReducer";
import { AppMode } from "../../http/protocol";
import { getContainer } from "../../ioc/IOCSetup";
import { useDispatch } from "react-redux";
import "../../assets/custom-icons/style.scss";
import { t } from "../../i18n";
import { isCasinoMenuItemActive, mapMenuItemData, MenuItemData } from "./MenuUtils";
import { showSideMenu } from "../../navigation/NavigationActions";
import { getMobileMenuItems } from "../../selectors/navigation-selectors";

export const MobileBottomMenu = () => {
  const dispatch = useDispatch();
  const menuItems = useAppSelector((state) => getMobileMenuItems(state));
  let lng = getContainer().getSettingsService().getActiveLocale().code ?? "";
  const displaySideMenu = useAppSelector((state) => state.navigation.isSideMenuExpanded);
  const pokerLoadingComplete = useAppSelector((state) => state.navigation.pokerLoadingComplete);
  const history = useHistory();
  const appMode = useAppSelector((state) => state.user.appMode);

  return (
    <Switch>
      {pokerLoadingComplete && <Route exact path="/poker/play"></Route>}
      <Route exact path="/casino/play/:gameId/:provider"></Route>
      <Route exact path="/casino/play/:gameId/:provider/:mode"></Route>
      <Route exact path={"/blocked/:country"}></Route>
      <Route exact path="/app"></Route>
      <Route path={"/"}>
        <nav className={"bottom-menu " + (appMode != AppMode.NONE ? "app" : "")}>
          {menuItems &&
            menuItems
              .map((m) => mapMenuItemData(m, lng, history.location.pathname))
              .map((m: MenuItemData) => (
                  <NavLink
                    key={"mm-" + m.name}
                    className={"mobile-menu-item"}
                    to={m.url}
                    activeClassName={"active"}
                    isActive={(match, location) => isCasinoMenuItemActive(match, location, m)}
                  >
                    <div className={"icon"}>
                      <i className={m.icon?.className ?? ""}>{m.icon?.text ?? ""}</i>
                    </div>
                    <div className={"menu-text"}>{m.text}</div>
                  </NavLink>
                )
              )}
          {displaySideMenu && (
            <button
              className={"mobile-menu-item active"}
              onClick={() => {
                dispatch(showSideMenu(false));
              }}
            >
              <div className={"icon"}>
                <span className={"material-icons"}>menu</span>
              </div>
              <div className={"menu-text"}>{t("navmenu.menu")}</div>
            </button>
          )}
          {!displaySideMenu && (
            <button
              className={"mobile-menu-item"}
              onClick={() => {
                dispatch(showSideMenu(true));
              }}
            >
              <div className={"icon"}>
                <span className={"material-icons"}>menu</span>
              </div>
              <div className={"menu-text"}>{t("navmenu.menu")}</div>
            </button>
          )}
        </nav>
      </Route>
    </Switch>
  );
};
export default MobileBottomMenu;
